<div id="content">
	<div id="main">
		<router-outlet></router-outlet>
	</div>
</div>
<bb-library-menu id="sidebar"></bb-library-menu>